<script lang="ts" setup>
import topLeft from "@/assets/image/services/usluge-elektroinstalacije.jpg";
import topCenter from "@/assets/image/services/usluge-solarne-eletrane.png";
import topRight from "@/assets/image/services/usluge-klima-uredjaji.png";
import bottomLeft from "@/assets/image/services/usluge-video-nadzor.png";
import bottomRight from "@/assets/image/services/usluge-toplotne-pumpe.png";
import { useDefaultStore } from "@/store";
import arrow from "@/assets/image/icons/arrow.svg";
import arrowForward from "@/assets/image/icons/arrow-forward.svg";
import { $t } from "@/i18n";
import type { RouteName } from "@/router";

const store = useDefaultStore();

const carousel = computed(() => [
  {
    image: topLeft,
    alt: "carousel",
    position: "top" as const,
    active: true,
    text: $t("app.homePage.aboutUs.carousel.1"),
    routeName: "ElectricalInstallationsPage" as RouteName,
  },
  {
    image: topCenter,
    alt: "carousel",
    position: "top" as const,
    active: false,
    text: $t("app.homePage.aboutUs.carousel.2"),
    routeName: "SolarPanelsPage" as RouteName,
  },
  {
    image: topRight,
    alt: "carousel",
    position: "top" as const,
    active: false,
    text: $t("app.homePage.aboutUs.carousel.3"),
    routeName: "AirConditioning" as RouteName,
  },
  {
    image: bottomLeft,
    alt: "carousel",
    position: "bottom" as const,
    active: false,
    text: $t("app.homePage.aboutUs.carousel.4"),
    routeName: "VideoSurveillancePage" as RouteName,
  },
  {
    image: bottomRight,
    alt: "carousel",
    position: "bottom" as const,
    active: false,
    text: $t("app.homePage.aboutUs.carousel.5"),
    routeName: "HeatPumpsPage" as RouteName,
  },
]);

const whyUs = computed(() => [
  $t("app.homePage.whyUs.1"),
  $t("app.homePage.whyUs.2"),
  $t("app.homePage.whyUs.3"),
  $t("app.homePage.whyUs.4"),
]);
</script>

<template>
  <m-section
    class="text-text-light flx-col w-full flex-col items-center bg-[linear-gradient(126.83deg,_#101010_33.34%,_rgba(16,16,16,0.6)_98.79%),url('@/assets/image/services/pozadina-tamna.png')] bg-cover bg-bottom-right bg-no-repeat"
  >
    <div class="mb-16 flex max-w-screen-xl flex-col">
      <section-heading :title="$t('app.homePage.ourServices.title')" class="text-text-light" text-align="center"></section-heading>
      <p class="mx-auto mb-8 max-w-[1113px] text-center leading-[150%] md:text-xl">
        {{ $t("app.homePage.ourServices.text") }}
      </p>

      <div
        v-if="!store.isWiderThan1307"
        class="aspect-[100/81] min-h-[324px] w-full max-w-[calc(100vw-32px)] overflow-hidden [@media(min-width:1307px)]:aspect-auto [@media(min-width:1307px)]:h-[892px]"
      >
        <carousel-comp :carousel="carousel">
          <template #default="{ item, active }">
            <services-card
              :image="item.image"
              :alt="item.alt as string"
              :text="item.text as string"
              :route-name="item.routeName as RouteName"
              :active="active"
            ></services-card>
          </template>
        </carousel-comp>
      </div>

      <div v-else class="w-full">
        <div class="mb-4 flex space-x-4">
          <template v-for="(g, i) in carousel" :key="i">
            <div v-if="g.position === 'top'" class="group relative flex h-[382px] flex-1 justify-center overflow-hidden rounded-2xl">
              <services-card :image="g.image" :alt="g.alt" :text="g.text" :route-name="g.routeName"></services-card>
            </div>
          </template>
        </div>

        <div class="flex space-x-4">
          <template v-for="(g, i) in carousel" :key="i">
            <div v-if="g.position === 'bottom'" class="group relative flex h-[382px] flex-1 justify-center overflow-hidden rounded-2xl">
              <services-card :image="g.image" :alt="g.alt" :text="g.text" :route-name="g.routeName"></services-card>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="flex w-full max-w-screen-xl flex-col">
      <section-heading :title="$t('app.homePage.whyUs.title')" class="text-text-light mb-4 md:mb-12" text-align="center"></section-heading>
      <div class="space-y-4 md:space-y-8">
        <div v-for="(n, index) in whyUs" :key="index" class="flex space-x-6">
          <span class="mr-1 block h-4 min-h-4 w-4 min-w-4 pt-1 md:mr-6 md:h-[34px] md:w-[47px] md:pt-0"
            ><img :src="store.isMobile ? arrowForward : arrow" alt="arrow"
          /></span>
          <span class="leading-[120%] md:pt-2 md:text-xl">{{ n }}</span>
        </div>
      </div>
    </div>
  </m-section>
</template>
